import type React from 'react';
import { useCallback } from 'react';
import {
	useFeedbackCollectorActions,
	ENTRYPOINT_ID_JIRA_PLATFORM,
	EntryKeys,
} from '@atlassian/jira-feedback-collector';
import { useIntl } from '@atlassian/jira-intl';
import { NAV4_OPT_OUT_FEEDBACK_GROUP_ID } from '../../constants';
import { messages } from './messages';

export const useNav4FeedbackCollector = () => {
	const { formatMessage } = useIntl();

	const { openFeedbackCollector, closeFeedbackCollector } = useFeedbackCollectorActions();

	const showFeedbackCollector = useCallback(
		(feedbackTitleDetails: React.ReactNode = null) => {
			const _feedbackTitleDetails =
				feedbackTitleDetails ?? formatMessage(messages.feedbackTitleDetailsNonFinal);

			openFeedbackCollector({
				feedbackGroupId: NAV4_OPT_OUT_FEEDBACK_GROUP_ID,
				entrypointId: ENTRYPOINT_ID_JIRA_PLATFORM,
				feedbackContext: getFeedbackContext(),
				feedbackTitle: formatMessage(messages.feedbackTitleNonFinal),
				feedbackTitleDetails: _feedbackTitleDetails,
			});
		},
		[formatMessage, openFeedbackCollector],
	);

	return { showFeedbackCollector, closeFeedbackCollector };
};

// can add more fields here
function getFeedbackContext() {
	return [
		{
			id: EntryKeys.OPT_OUT,
			value: 'Yes',
		},
	];
}
